import { useState, useEffect, useContext, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Form, Col } from 'react-bootstrap';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import '../../pages/Searchs/styles.css';
import If from '../../components/If';
import Loading from '../../components/Loading';
import Button from '../../components/Button';
import EditButton from '../../components/EditButton';
import DuplicateButton from '../../components/DuplicateButton';
import HistoryButton from '../../components/HistoryButton';
import PDFButton from '../../components/GeneratePDF';
import ZipButton from '../../components/GenerateZip';
import SearchEmpty from '../../components/SearchEmpty';
import CadernoLPMAHistoricoModal from './CadernoLPMAHistoricoModal';
import Select from 'react-select';
import api, { apiFileDownload } from '../../services/api';
import { _generateDate } from '../../util/convert';
import LoadingInForm from '../../components/LoadingInForm';
import { CadernoLPMA, TecnicoPrincipal } from '../../models/modelsCadernoLPMA';
import { STRINGS_CADERNOLPMA } from '../../util/cadernoLPMA/string';
import { Context } from '../../context/AuthContext';
import jwtDecode from 'jwt-decode';
import { DecodedToken } from '../../models/user';
import { getCadernoLpmaFormEditFlags } from '../../users/CadernoLPMA/cadernoLpmaFormPermissions';

export default function Caderno_LPMA() {
	const history = useHistory();
	const { token } = useContext(Context);
	const formFlags = useMemo(() => {
		if (!token?.access_token) {
			return getCadernoLpmaFormEditFlags([]);
		}
		try {
			const decoded = jwtDecode<DecodedToken>(token.access_token);
			return getCadernoLpmaFormEditFlags(decoded?.roles);
		} catch {
			return getCadernoLpmaFormEditFlags([]);
		}
	}, [token?.access_token]);
	const podeAdicionarCaderno = formFlags.canEditDadosPrincipais;
	const podeCopiarCaderno = formFlags.canEditDadosPrincipais;
	const podeEditarCaderno = formFlags.canMutate;

	useEffect(() => {
		if (!formFlags.canView) {
			history.replace('/');
		}
	}, [formFlags.canView, history]);
	const [errorSearch, setErrorSearch] = useState<any>(null);
	const [emptySearch, setEmptySearch] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(true);
	const [loadingSearch, setLoadingSearch] = useState<boolean>(false);
	const [cadernosLPMA, setCadernosLPMA] = useState<CadernoLPMA[]>([]);
	const [tecnicosPrincipais, setTecnicosPrincipais] = useState<TecnicoPrincipal[]>([]);
	const [responsaveisCampo, setResponsaveisCampo] = useState<TecnicoPrincipal[]>([]);
	const [pdfLoadingId, setPdfLoadingId] = useState<number | null>(null);
	const [zipLoadingId, setZipLoadingId] = useState<number | null>(null);
	const [copyLoadingId, setCopyLoadingId] = useState<number | null>(null);
	const [historicoModalShow, setHistoricoModalShow] = useState<boolean>(false);
	const [historicoModalCadernoId, setHistoricoModalCadernoId] = useState<number | null>(null);
	//const [culturas, setCulturas] = useState<CulturaResult[]>([]);
	//const [materiais, setMateriais] = useState<CulturaResult[]>([]);

	const initialValues: CadernoLPMA = {
		id: 0,
		codigo: '',
		projeto: '',
		municipio: '',
		uf: '',
		culturaId: '',
		nomeCientificoId: '',
		local: '',
		ensaios: '',
		totalEnsaios: null,
		tecnicoPrincipalId: '',
	}

	const { register, errors, handleSubmit, getValues, control, formState: { isDirty } } = useForm({
		defaultValues: initialValues,
		mode: 'onTouched',
	})

	const tecnicoPrincipalNomePorId = useMemo(() =>
		tecnicosPrincipais.reduce((acc, t) => { acc[t.id] = t.nome; return acc; }, {} as Record<number, string>),
	[tecnicosPrincipais]);

	const responsavelCampoNomePorId = useMemo(() =>
		responsaveisCampo.reduce((acc, t) => { acc[t.id] = t.nome; return acc; }, {} as Record<number, string>),
	[responsaveisCampo]);

	const getData = async () => {
		try {
			const [tecnicos, responsaveis] = await Promise.all([
				api.get<TecnicoPrincipal[]>('api/v1/cadernoLPMA/cadernoLPMA/tecnicos-principais'),
				api.get<TecnicoPrincipal[]>('api/v1/cadernoLPMA/cadernoLPMA/tecnicos-responsaveis-campo'),
			]);
			if (tecnicos.status === 200) setTecnicosPrincipais(tecnicos.data);
			if (responsaveis.status === 200) setResponsaveisCampo(responsaveis.data);
		} catch { }
	}

	const getCadernoLPMA = async () => {
		setLoading(true);
		setErrorSearch(null);
		
		try {
			const { data, status } = await api.get<CadernoLPMA[]>('api/v1/cadernoLPMA/cadernoLPMA/obtertodos');

			if (status === 200) {
				setCadernosLPMA(data);
				setEmptySearch(data.length === 0);
			}
		} catch (error: any) {
			setErrorSearch(error?.response?.data);
		} finally {
			setLoading(false);
		}
	}

	useEffect(() => {
		getData();
		getCadernoLPMA();
	}, []);

	const search = async (queries?: any) => {
		let projeto = getValues('projeto');

		//let cultura = queries?.cultureId !== "" ? parseInt(queries?.cultureId) : 0;

		setLoadingSearch(true);
		setErrorSearch(null);

		try {
			const { data } = await api.get<CadernoLPMA[]>(`api/v1/cadernoLPMA/cadernoLPMA/obterporfiltro?projeto=${projeto}`);

			if (data.length) {
				setCadernosLPMA(data);
				setEmptySearch(false);
			} else {
				setEmptySearch(true);
			}

		} catch (error: any) {
			setErrorSearch(error?.response?.data);
		}
		setLoadingSearch(false);
	}

	const handleDownloadPdf = async (id: number, codigo?: string) => {
		try {
			setPdfLoadingId(id);
			const { data } = await apiFileDownload.get(`api/v1/cadernoLPMA/cadernoLPMA/downloadpdf/${id}`);
			const blob = new Blob([data], {
				type: 'application/pdf'
			});

			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			const normalizedCode = (codigo && codigo.trim().length ? codigo.trim() : `ID_${id}`).replace(/[^\w\-]/g, '_');

			link.href = url;
			link.download = `Caderno_LPMA_${normalizedCode}.pdf`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

			window.URL.revokeObjectURL(url);
		} catch (error: any) {
			console.error('Erro ao gerar PDF do Caderno LPMA', error);
		} finally {
			setPdfLoadingId(null);
		}
	}

	const handleDownloadZip = async (id: number, codigo?: string) => {
		try {
			setZipLoadingId(id);
			const { data } = await apiFileDownload.get(`api/v1/cadernoLPMA/cadernoLPMA/downloadzip/${id}`);
			const blob = new Blob([data], {
				type: 'application/zip'
			});

			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			const normalizedCode = (codigo && codigo.trim().length ? codigo.trim() : `ID_${id}`).replace(/[^\w\-]/g, '_');

			link.href = url;
			link.download = `Caderno_LPMA_${normalizedCode}.zip`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

			window.URL.revokeObjectURL(url);
		} catch (error: any) {
			console.error('Erro ao gerar ZIP do Caderno LPMA', error);
		} finally {
			setZipLoadingId(null);
		}
	}

	const handleCopiar = async (id: number) => {
		setCopyLoadingId(id);
		try {
			const response = await api.get<CadernoLPMA>(`api/v1/cadernoLPMA/CadernoLPMA/${id}`);
			if (response.status === 200) {
				const d = response.data;
				const dadosParaCopiar: CadernoLPMA = {
					processoInternoBasf: d.processoInternoBasf,
					tituloLPMA: d.tituloLPMA,
					processoCTNBio: d.processoCTNBio,
					projeto: d.projeto,
					culturaId: d.culturaId,
					cultura: d.cultura,
					nomeCientificoId: d.nomeCientificoId,
					nomeCientifico: d.nomeCientifico,
					local: d.local,
					uf: d.uf,
					municipio: d.municipio,
					tecnicoPrincipalId: d.tecnicoPrincipalId,
					tecnicoPrincipal: d.tecnicoPrincipal,
					responsavelTecnicoEnsaioCampoId: d.responsavelTecnicoEnsaioCampoId,
					responsavelTecnicoEnsaioCampo: d.responsavelTecnicoEnsaioCampo,
					assistenteTecnicoEnsaioCampoId: d.assistenteTecnicoEnsaioCampoId,
					assistenteTecnicoEnsaioCampo: d.assistenteTecnicoEnsaioCampo,
					totalEnsaios: d.totalEnsaios,
					totalEnsaiosAprovados: d.totalEnsaiosAprovados,
					ensaios: d.ensaios,
					documentosPrincipais: d.documentosPrincipais?.map(({ id: _id, ...doc }) => doc as any),
				};
				history.push('/cadernoLPMA/cadastrar/', { initialEntity: dadosParaCopiar });
			}
		} catch (error) {
			console.error('Erro ao copiar Caderno LPMA', error);
		} finally {
			setCopyLoadingId(null);
		}
	};

	const actions = ({ data }: any) => (
		<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
			{podeEditarCaderno ? (
				<EditButton
					onClick={() => history.push(`/cadernoLPMA/editar/${data.id}`)}
				/>
			) : (
				<EditButton
					tooltip="Visualizar"
					onClick={() => history.push(`/cadernoLPMA/editar/${data.id}`)}
				/>
			)}
			{podeCopiarCaderno && (
				<DuplicateButton
					tooltip="Copiar"
					onClick={() => handleCopiar(data.id)}
					disable={copyLoadingId === data.id}
				/>
			)}
			<HistoryButton
				onClick={() => {
					setHistoricoModalCadernoId(data.id);
					setHistoricoModalShow(true);
				}}
			/>
			<PDFButton
				onClick={() => handleDownloadPdf(data.id, data.codigo)}
				isLoading={pdfLoadingId === data.id}
			/>
			<ZipButton
				Text={zipLoadingId === data.id ? 'Gerando Zip' : 'Gerar Zip'}
				onClick={() => zipLoadingId === null && handleDownloadZip(data.id, data.codigo)}
			/>
		</div>
	)

	return <div className="container-custom-search">
		<div className="top-content">
			<h3>{STRINGS_CADERNOLPMA.SEARCH_CADERNO_LPMA}</h3>
		</div>
		<div className="row-buttons">
			<If condition={podeAdicionarCaderno}>
				<Button
					onClick={() => history.push('/cadernoLPMA/cadastrar/')}
					contained
					title="Adicionar"
					type="button"
				/>
			</If>
		</div>
		<br />
		<Form onSubmit={handleSubmit(search)}>
			<Form.Row className="row-custom">
				<Form.Group as={Col} md={3}>
					<Form.Label>Projeto</Form.Label>
					<Form.Control
						ref={register}
						name="projeto"
						maxLength={15}
						autoComplete="off"
					/>
				</Form.Group>
				<span className="filter-btn">
					<Button
						title="Buscar"
						type="submit"
						contained
						isLoading={loadingSearch}
					/>
				</span>
			</Form.Row>
		</Form>
		<If condition={!loading && !emptySearch && cadernosLPMA.length}>
			<div className="search-content">
				<div className="ag-theme-alpine" style={{ height: '70vh', width: '100%' }}>
					<AgGridReact
						rowData={cadernosLPMA}
						defaultColDef={{ flex: 1, sortable: true, resizable: true }}
						pagination
						paginationPageSize={10}
						frameworkComponents={{
							actions: actions,
						}}
					>
						<AgGridColumn
							headerName='ID'
							field="id"
							cellStyle={{
								justifyContent: 'left'
							}}
							sort="desc"
						/>
						<AgGridColumn
							headerName='Processo Interno'
							field="processoInternoBasf"
							cellStyle={{
								justifyContent: 'left'
							}}
						/>
						<AgGridColumn
							headerName='Local'
							field="local"
							cellStyle={{
								justifyContent: 'left'
							}}
							sort="asc"
						/>
						<AgGridColumn
							headerName='Responsável Técnico'
							field="responsavelTecnicoEnsaioCampoId"
							valueFormatter={({ data }: any) => {
								const id = data?.responsavelTecnicoEnsaioCampoId;
								if (!id) return '';
								return responsavelCampoNomePorId[id] ?? '';
							}}
							cellStyle={{
								justifyContent: 'left'
							}}
						/>
						<AgGridColumn
							headerName='Assistente Técnico'
							field="assistenteTecnicoEnsaioCampoId"
							valueFormatter={({ data }: any) => {
								const id = data?.assistenteTecnicoEnsaioCampoId;
								if (!id) return '';
								return responsavelCampoNomePorId[id] ?? '';
							}}
							cellStyle={{
								justifyContent: 'left'
							}}
						/>
						<AgGridColumn
							headerName='Técnico Principal'
							field="tecnicoPrincipalId"
							valueFormatter={({ data }: any) => {
								const id = data?.tecnicoPrincipalId;
								if (!id) return '';
								return tecnicoPrincipalNomePorId[id] ?? '';
							}}
							cellStyle={{
								justifyContent: 'left'
							}}
						/>
						<AgGridColumn
							headerName='Projeto'
							field="projeto"
							cellStyle={{
								justifyContent: 'left'
							}}
							sort="asc"
						/>
						<AgGridColumn
							headerName='Ações'
							cellRenderer='actions'
							maxWidth={200}
						/>
					</AgGridReact>
				</div>
			</div>
		</If>
		<If condition={loading}>
			<div className="loading-container">
				<Loading />
			</div>
		</If>
		<If condition={emptySearch}>
			<div className="div-empty">
				<SearchEmpty />
			</div>
		</If>
		<CadernoLPMAHistoricoModal
			show={historicoModalShow}
			onHide={() => {
				setHistoricoModalShow(false);
				setHistoricoModalCadernoId(null);
			}}
			cadernoLPMAId={historicoModalCadernoId}
		/>
	</div>;
}